<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else-if="!$root.Permissions.integrator()">
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Pacotes de publicidades para Instagram</div>
                <div class="text text--thin mb-2">Adicione um novo pacote</div>
                <v-btn @click="dialogNovo = true" color="primary" class="mt-1"><v-icon class="mr-1">add_photo_alternate</v-icon>Novo pacote</v-btn>
              </v-col>
              <v-col cols="12" md="5">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        disable-sort
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <v-row no-gutters>
              <div class="py-2 px-2">
                <v-form @submit.prevent="applyFilter()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
              </div>
              <div class="py-2 px-2" v-if="$root.Permissions.admin()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="distribuidor"
                  :items="distribuidores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Distribuidor"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
            </v-row>
          </v-row>
        </template>
        <template v-slot:item.pub_imagem="{ item }">
          <img class="instagram_imagem" :src="item.pub_imagem" alt="Imagem">
        </template>
        <template v-slot:item.pub_nome="{ item }">
          <span class="d-flex align-center item-link">
            <a :href="item.pub_pacote" target="_blank" :class="$vuetify.theme.dark ? 'text-white' : 'text-black'">
              <span>{{ item.pub_nome }}</span>
              <v-icon size="15">open_in_new</v-icon>
            </a>
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{instagram.uuid_pub_id ? 'Editar instagram' : 'Novo instagram'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formInstagram">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                v-model="instagram.pub_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="pacote"
                v-model="instagram.pub_pacote"
                prepend-icon="inventory_2"
                label="Adicionar pacote de imagens* (.zip)"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                :rules="[rules.required, rules.size]"
                outlined
                v-if="isObject(instagram.pub_pacote)"
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="instagram.pub_pacote && !isObject(instagram.pub_pacote)">
              <v-row no-gutters justify="start" align="center">
                <div v-if="instagram.pub_pacote">
                  <span class="d-flex align-center item-link">
                    <a :href="instagram.pub_pacote" target="_blank">
                      <v-icon size="15">download</v-icon>
                      <span>Baixar pacote salvo</span>
                    </a>
                  </span>
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-3" @click="instagram.pub_pacote = null" v-bind="attrs" v-on="on" color="primary">edit</v-icon>
                    </template>
                    <span>Alterar pacote</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="instagram.pub_imagem"
                prepend-icon="image"
                label="Adicionar imagem de capa*"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                :rules="[rules.required, rules.size]"
                hint="Tamanho recomendado: 470x585px"
                persistent-hint
                v-if="isObject(instagram.pub_imagem)"
                outlined
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="instagram.pub_imagem && !isObject(instagram.pub_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div v-if="instagram.pub_imagem">
                  <img alt="Imagem" :src="instagram.pub_imagem" class="imagem">
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="instagram.pub_imagem = null" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover imagem</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditPhoto()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Logotipo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover a imagem?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Instagram
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Instagram <b class="text-primary">{{instagram ? instagram.pub_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeInstagram()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  watch: {
    options: {
      handler () {
        this.getPhotos()
      },
      deep: true
    }
  },
  data () {
    return {
      loading: true,
      carregando: false,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogDeletarImagem: false,
      search: '',
      modulos: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'pub_id'
        },
        { text: 'Nome', value: 'pub_nome' },
        { text: 'Imagem de capa', value: 'pub_imagem' },
        { text: 'Distribuidor', value: 'distribuidor.dis_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 130
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!'
      },
      instagram: {
        pub_nome: '',
        pub_imagem: '',
        pub_pacote: ''
      },
      options: {},
      total: 0,
      distribuidor: null,
      distribuidores: []
    }
  },
  methods: {
    loadFunctions () {
      let filters = this.$route.query
      if (filters.busca) this.search = filters.busca
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      this.removeHeader()
      this.getDistributors()
      this.loading = false
    },
    removeHeader () {
      if (!this.$root.Permissions.admin()) {
        delete this.headers[3]
      }
    },
    getDistributors () {
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome_fantasia
              })
            })
            this.distribuidores = info
          }
        })
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getPhotos () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`
      if (this.distribuidor) endpoint += '&distribuidor=' + this.distribuidor

      await Api.get(`publicidades?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          let info = []
          if (res.data) {
            if (res.data.data.length > 0) {
              res.data.data.map(item => {
                info.push({
                  pub_id: item.pub_id,
                  pub_nome: item.pub_nome,
                  pub_imagem: item.pub_imagem,
                  pub_pacote: item.pub_pacote,
                  uuid_pub_id: item.uuid_pub_id,
                  distribuidor: item.distribuidor
                })
              })
            }
            this.total = res.data.total
          }
          this.dados = info
          this.loading = false
          this.carregando = false
        })
        .catch(err => {
          this.loading = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os instagrams!',
            color: 'error'
          })
          console.log(err)
        })
    },
    limparBusca () {
      this.search = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      this.carregando = true

      let query = Object.assign({},
        this.search ? { busca: this.search } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : ''
      )

      this.$router.replace({name: this.$route.name, query: query}).catch(() => {})

      this.options.page = 1
      this.getPhotos()
    },
    removeImagem () {
      this.instagram.pub_imagem = ''
      this.instagram.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    saveEditPhoto () {
      if (!this.$refs.formInstagram.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'publicidades/novo'
      let editado = false
      if (this.instagram.uuid_pub_id) {
        endpoint = 'publicidades/edita'
        editado = true
      }
      console.log(this.instagram, 'this.instagram')
      const formData = new FormData()
      Object.keys(this.instagram).map((key) => {
        if (key === 'pub_imagem') {
          if (this.$refs.file) {
            formData.append(`pub_imagem`, this.instagram.pub_imagem)
          }
        } else if (key === 'pub_pacote') {
          if (this.$refs.pacote) {
            formData.append(`pub_pacote`, this.instagram.pub_pacote)
          }
        } else {
          if (this.instagram[key] != null) {
            formData.append(key, this.instagram[key])
          }
        }
      })
      console.log(formData, 'formData')

      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Pacote atualizado com sucesso!' : 'Pacote cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getPhotos()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeInstagram () {
      this.salvando = true
      Api.delete(`publicidades/remove/${this.instagram.uuid_pub_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getPhotos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover pacote!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.instagram = JSON.parse(JSON.stringify(item))
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.instagram = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.instagram = {
        pub_nome: '',
        pub_imagem: '',
        pub_pacote: ''
      }
      if (this.$refs.formInstagram) {
        this.$refs.formInstagram.resetValidation()
      }
      this.dialogNovo = false
    }
  },
  created () {
    if (this.$root.Permissions.integrator()) {
      this.$router.push({ name: 'Home' }).catch(() => {})
    }
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.imagem {
  max-height: 250px;
  max-width: 250px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
.instagram_imagem {
  max-height: 100px;
  margin: 5px 0;
  max-width: 200px;
}

.item {
  &-link a {
    cursor: pointer;
    transition: 0.3s ease;
    text-decoration: none;
    &:hover * {
      color: $primary;
      transition: 0.3s ease;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Instagram.vue